/**
 *
 * <DatePicker />
 *
 * This datepicker is designed to be used in a redux-form
 * as the 'component' prop of a `redux-form.Field`.
 *
 */
import React, { useRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMAT_SANS_TIME } from 'common';
import moment from 'moment';

const DatePicker = (field) => {
  const pickerRef = useRef(null);

  /**
   * Fix issue where datepicker onClickOutside conflicts with react-select.
   * https://github.com/Hacker0x01/react-datepicker/issues/730#issuecomment-413396011
   */
  function handleClickOutside() {
    pickerRef.current.cancelFocusInput();
    pickerRef.current.setOpen(false);
  }

  return (
    <ReactDatePicker
      isClearable
      className="form-control"
      dateFormat={DEFAULT_DATE_FORMAT_SANS_TIME}
      onClickOutside={handleClickOutside}
      ref={pickerRef}
      selected={initializeDateField(field, DEFAULT_DATE_FORMAT_SANS_TIME)}
      onChange={(date, event) => {
        const dt = moment(date);
        field.input.onChange(dt.isValid() ? dt.format(DEFAULT_DATE_FORMAT_SANS_TIME) : '');
        if (event) {
          event.preventDefault();
        }
      }}
    />
  );
};

export const initializeDateField = (field, dateFormat) => {
  let dt = null;
  if (field.input && field.input.value) {
    const value = field.input.value.replace(/[+]/g, ' ');
    dt = moment(value, dateFormat);
    if (!dt.isValid()) {
      dt = moment(value, moment.ISO_8601);
    }
  }
  return dt;
};


export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js